import { defineStore } from 'pinia'
import type { User } from '@/models/auth'

interface AuthState {
  token: string | null
  user: User | null
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    token: localStorage.getItem('authToken'),
    user: null,
  }),

  getters: {
    isUserSignedIn: (state): boolean => !!state.token,
    currentUser: (state): User | null => state.user,
    isUserEmailConfirmed: (state): boolean => !!state.user?.confirmed_at,
  },

  actions: {
    setAuth(token: string, user: User) {
      this.token = token
      this.user = user
      localStorage.setItem('authToken', token)
    },

    clearAuth() {
      this.token = null
      this.user = null
      localStorage.removeItem('authToken')
    },
  },
})
